/**
 * Adventure expedition unit families
 * Extracted from families.js for better encapsulation
 */

const AdventureFamilies = {
    EXPEDITION_IDS: ["adventure", "adventure2", "adventure3", "adventure4", "adventureny", "adventurevd", "patrickday", "earthday", "nightparty", "pirates", "testadv", "laborday26"],
    NEWER_EXPEDITION_IDS: ["adventure3", "adventure4", "adventureny", "adventurevd", "patrickday", "earthday", "nightparty", "pirates", "testadv", "laborday26"],
    NEWER_EXPEDITION_IDS_CLASSIC_PRODUCT: ["adventure3", "adventure4", "adventureny", "adventurevd", "patrickday", "earthday", "nightparty", "testadv"],
    ADV2_PLUS_IDS: ["adventure2", "adventure3", "adventure4", "adventureny", "adventurevd", "patrickday", "earthday", "nightparty", "pirates", "testadv", "laborday26"],
    EXPEDITION_IDS_CLASSIC_SOURCES: ["adventure", "adventure2", "adventure3", "adventure4", "adventureny", "adventurevd", "patrickday", "earthday", "testadv"],
    NEW_SOURCE_IDS: ["nightparty", "pirates", "laborday26"],
    NEW_PRODUCT_IDS: ["pirates", "laborday26"],

    register: function () {
        this.addDesignExpeditions();
        this.registerSharedFamilies();
        this.registerPrizeFamilies();
        this.registerSourceFamilies();
        this.registerCustomerFamilies();
        this.registerGeneratorFamilies();
        this.registerProducerFamilies();
        this.registerMiscFamilies();
    },

    // an adventure expedition described in its design folder
    addDesignExpeditions: function () {
        const lists = [this.EXPEDITION_IDS, this.NEWER_EXPEDITION_IDS, this.ADV2_PLUS_IDS, this.NEW_SOURCE_IDS, this.NEW_PRODUCT_IDS];

        ExpeditionDesign.list().filter((design) => design.type === "adventure").forEach((design) => {
            lists.filter((ids) => !ids.includes(design.id)).forEach((ids) => {
                ids.push(design.id);
            });
        });
    },

    registerSharedFamilies: function () {
        // Add adventure2 to shared rp-families expeditions
        const sharedFamilies = [
            "rpproduct0", "rpproduct1", "rpproduct2", "rpproduct3", "rpproduct4",
            "rpproducer0", "rpproducer1", "rpproducer2", "rpproducer3", "rpproducer4",
            "rpcustomerbridge0", "rpcustomerbridge1", "rpcustomerbridge2", "rpcustomerbridge3", "rpcustomerbridge4",
            "rpcustomermain0", "rpcustomermain1", "rpcustomermain2", "rpcustomermain3", "rpcustomermain4"
        ];

        sharedFamilies.forEach((familyName) => {
            if (Families[familyName]) {
                Families[familyName].expeditions.push("adventure2");
                if (!familyName.includes("rpproducer")) {
                    Families[familyName].units.forEach((unit) => {
                        unit.cookingAnimation = {
                            adventure2: true
                        };
                    });
                }
            }
        });

        if (Families.rpcustomerbridge0) {
            Families.rpcustomerbridge0.units.forEach((unit) => {
                if (unit.multicell) {
                    unit.multicell.adventure2 = FamiliesHelper.Shape1x3Vertical;
                }
            });
        }
        if (Families.rpcustomerbridge2) {
            Families.rpcustomerbridge2.units.forEach((unit) => {
                if (unit.multicell) {
                    unit.multicell.adventure2 = FamiliesHelper.Shape1x6;
                }
            });
        }

        // Add all adventure expeditions to energy family
        if (Families.energy) {
            this.EXPEDITION_IDS.forEach((expeditionId) => {
                Families.energy.expeditions.push(expeditionId);
            });
        }

        const adventureMovable = Object.fromEntries(this.EXPEDITION_IDS.map((id) => [id, false]));
        const adventureUnmergeableIn = Object.fromEntries(this.EXPEDITION_IDS.map((id) => [id, true]));
        ["coins", "rubies", "energy"].forEach((code) => {
            if (Families[code]) {
                Families[code].units.forEach((unit) => {
                    if (unit.collectible) {
                        unit.movable = adventureMovable;
                        unit.unmergeableIn = adventureUnmergeableIn;
                    }
                });
            }
        });
    },

    registerPrizeFamilies: function () {
        // advgift - energy prizes
        Families.advgift = AdventureFamiliesHelper.AdventurePrizesFamily([{
            unlock: "3 minutes",
            prize: [{ resource: "hard", amount: 1 }, { resource: "energy", amount: 5 }]
        }, {
            unlock: "5 minutes",
            prize: { resource: "energy", amount: 10 }
        }, {
            unlock: "5 minutes",
            prize: { resource: "energy", amount: 10 }
        }], {
            type: "advprize",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advenergy - energy prizes
        Families.advenergy = AdventureFamiliesHelper.AdventurePrizesFamily([{
            unlock: "8 minutes",
            prize: { resource: "energy", amount: 15 }
        }, {
            unlock: "5 minutes",
            prize: { resource: "energy", amount: 10 }
        }, {
            unlock: "5 minutes",
            prize: { resource: "energy", amount: 10 }
        }, {
            unlock: "3 minutes",
            prize: { resource: "energy", amount: 5 }
        }, {
            unlock: "3 minutes",
            prize: { resource: "energy", amount: 10 }
        }], {
            type: "advprize",
            expeditions: this.NEW_SOURCE_IDS,
            quest: "advenergy"
        });

        // advreward - ingredient prizes
        Families.advreward = AdventureFamiliesHelper.AdventurePrizesFamily([{
            unlock: "1 minutes",
            prize: [
                { ingredient: "advlog", amount: [1, 4] },
                { ingredient: "advstick", amount: [1, 4] }
            ]
        }, {
            unlock: "1 minutes",
            prize: { ingredient: "advstone", amount: [1, 2] }
        }, {
            unlock: "1 minutes",
            prize: [
                { ingredient: "advgrass", amount: [2, 3] },
                { ingredient: "advleaves", amount: [2, 3] }
            ]
        }, {
            unlock: "1 minutes",
            prize: [
                { ingredient: "advblueberry", amount: 1 },
                { ingredient: "advlychee", amount: 2 },
                { ingredient: "advbanana", amount: 2 }
            ]
        }, {
            unlock: "3 minutes",
            prize: [
                { ingredient: "advgrass", amount: 1 },
                { ingredient: "advleaves", amount: 1 },
                { ingredient: "advlog", amount: 1 },
                { ingredient: "advstone", amount: 1 },
                { ingredient: "advstick", amount: 1 }
            ]
        }], {
            type: "advprize",
            expeditions: this.NEW_SOURCE_IDS,
            quest: "advreward"
        });

        // advchest - energy and hard currency prizes
        Families.advchest = AdventureFamiliesHelper.AdventurePrizesFamily([{
            unlock: "8 minutes",
            prize: { resource: "energy", amount: 15 }
        }, {
            unlock: "10 minutes",
            prize: { resource: "hard", amount: 5 }
        }], {
            type: "advprize",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advpile - ingredient prizes
        Families.advpile = AdventureFamiliesHelper.AdventurePrizesFamily([{
            unlock: "1 minutes",
            prize: { ingredient: "advdoubloon", amount: 1 }
        }, {
            unlock: "1 minutes",
            prize: [
                { ingredient: "advlog", amount: [1, 4] },
                { ingredient: "advstick", amount: [1, 4] }
            ]
        }, {
            unlock: "1 minutes",
            prize: { ingredient: "advstone", amount: [1, 2] }
        }, {
            unlock: "1 minutes",
            prize: [
                { ingredient: "advgrass", amount: [2, 3] },
                { ingredient: "advleaves", amount: [2, 3] }
            ]
        }, {
            unlock: "1 minutes",
            prize: [
                { ingredient: "advblueberry", amount: 1 },
                { ingredient: "advlychee", amount: 2 },
                { ingredient: "advbanana", amount: 2 }
            ]
        }], {
            type: "advprize",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advrush - quick energy prizes
        Families.advrush = AdventureFamiliesHelper.AdventurePrizesFamily([{
            unlock: "1 minutes",
            prize: { resource: "energy", amount: 3 }
        }, {
            unlock: "1 minutes",
            prize: { resource: "energy", amount: 3 }
        }, {
            unlock: "1 minutes",
            prize: { resource: "energy", amount: 3 }
        }, {
            unlock: "3 minutes",
            prize: { resource: "energy", amount: 5 }
        }, {
            unlock: "3 minutes",
            prize: { resource: "energy", amount: 5 }
        }, {
            unlock: "3 minutes",
            prize: { resource: "energy", amount: 10 }
        }, {
            unlock: "3 minutes",
            prize: [
                { ingredient: "advgrass", amount: 1 },
                { ingredient: "advleaves", amount: 1 },
                { ingredient: "advlog", amount: 1 },
                { ingredient: "advstone", amount: 1 },
                { ingredient: "advstick", amount: 1 }
            ]
        }], {
            type: "advprize",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advfireplace - stone prizes
        Families.advfireplace = AdventureFamiliesHelper.AdventurePrizesFamily({
            unlock: "3 minutes",
            prize: { ingredient: "advstone", amount: 3 }
        }, {
            multicell: FamiliesHelper.ShapeSquare,
            type: "advprize",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });
    },

    registerSourceFamilies: function () {
        // advshrub
        Families.advshrub = AdventureFamiliesHelper.AdventureLeveledSourceFamily([{
            energy: 9,
            prizes: { advgrass: 3 }
        }, {
            energy: 0,
            prizes: { energy: 1 }
        }], {
            type: "advsource",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advrock
        Families.advrock = AdventureFamiliesHelper.AdventureLeveledSourceFamily([{
            energy: 8,
            prizes: { advstone: 1 }
        }, {
            energy: 14,
            prizes: { advstone: 2 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 18,
            prizes: { advstone: 3 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 25,
            prizes: { advstone: 4 },
            multicell: FamiliesHelper.ShapeSquare
        }], {
            type: "advsource",
            expeditions: this.EXPEDITION_IDS
        });

        // advlawn
        Families.advlawn = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 4,
            prizes: { advgrass: 1 }
        }, {
            energy: 4,
            prizes: { advgrass: 1 }
        }, {
            energy: 4,
            prizes: { advgrass: 1 }
        }], {
            type: "advsource",
            expeditions: this.EXPEDITION_IDS
        });

        // advbush
        Families.advbush = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 5,
            prizes: { advstick: 1 }
        }, {
            energy: 12,
            prizes: { advstick: 2 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 9,
            prizes: { advleaves: 2, advstick: 2 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 11,
            prizes: { advstick: 2 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 8,
            prizes: { advleaves: 1, advblueberry: 2, advstick: 2 }
        }, {
            energy: 12,
            prizes: { advstick: 2 }
        }, {
            energy: 7,
            prizes: { advstick: 1, advblueberry: 1, advleaves: 1 }
        }, {
            energy: 11,
            prizes: { advleaves: 2, advbanana: 1, advstick: 1 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 6,
            prizes: { advleaves: 1 }
        }], {
            type: "advsource",
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advsource0
        Families.advsource0 = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 9,
            prizes: { advleaves: 2, advstick: 2 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 8,
            prizes: { advleaves: 1, advblueberry: 2, advstick: 2 }
        }, {
            energy: 7,
            prizes: { advstick: 1, advblueberry: 1, advleaves: 1 }
        }, {
            energy: 11,
            prizes: { advleaves: 2, advbanana: 1, advstick: 1 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 6,
            prizes: { advleaves: 1 }
        }], {
            type: "advsource",
            expeditions: this.NEW_SOURCE_IDS
        });
        //
        // advsource1
        Families.advsource1 = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 28,
            prizes: { advlog: 2, advleaves: 3, advlychee: 2 }
        }], {
            type: "advsource",
            pointOfInterest: true,
            expeditions: this.NEW_SOURCE_IDS
        });

        // advflower (adventure2+)
        Families.advflower = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 5,
            prizes: { advgrass: 1, advblueberry: 1 }
        }, {
            energy: 5,
            prizes: { advgrass: 1, advlychee: 1 }
        }, {
            energy: 5,
            prizes: { advgrass: 1, advlychee: 1 }
        }, {
            energy: 5,
            prizes: { advgrass: 1 }
        }], {
            type: "advsource",
            expeditions: this.ADV2_PLUS_IDS
        });

        // advtree
        Families.advtree = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 19,
            prizes: { advlog: 3, advstick: 1 }
        }, {
            energy: 17,
            prizes: { advlog: 3 }
        }, {
            energy: 28,
            prizes: { advlog: 2, advleaves: 3, advlychee: 2 }
        }, {
            energy: 22,
            prizes: { advlog: 3, advstick: 1 }
        }, {
            energy: 37,
            prizes: { advlog: 6, advstick: 4 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 10,
            prizes: { advorange: 1 }
        }], {
            type: "advsource",
            pointOfInterest: true,
            expeditions: this.EXPEDITION_IDS_CLASSIC_SOURCES
        });

        // advpalmtree (adventure2+)
        Families.advpalmtree = AdventureFamiliesHelper.AdventureSourceFamily([{
            energy: 15,
            prizes: { advleaves: 2, advlog: 2, advbanana: 1 }
        }, {
            energy: 20,
            prizes: { advleaves: 2, advlog: 3, advbanana: 2 }
        }, {
            energy: 18,
            prizes: { advleaves: 2, advlog: 2, advbanana: 2 }
        }, {
            energy: 18,
            prizes: { advlog: 2, advlychee: 1 }
        }, {
            energy: 30,
            prizes: { advlog: 3, advlychee: 3 },
            multicell: FamiliesHelper.ShapeSquare
        }, {
            energy: 20,
            prizes: { advlog: 2, advlychee: 1 }
        }], {
            type: "advsource",
            pointOfInterest: true,
            expeditions: this.ADV2_PLUS_IDS
        });
    },

    registerGeneratorFamilies: function () {
        const guideWindowByLocation = {};
        const multicellShape = {};
        this.ADV2_PLUS_IDS.forEach((location) => {
            if (bundles[`${location}_advgenerator_guide_window`]) {
                guideWindowByLocation[location] = {
                    name: "AdvGeneratorGuideWindow",
                    bundle: bundles[`${location}_advgenerator_guide_window`]
                };
            }
            multicellShape[location] = FamiliesHelper.ShapeSquare;
        });
        multicellShape.laborday26 = AdventureFamiliesHelper.Shape2x3;
        Families.advgenerator0 = AdventureFamiliesHelper.SpecialUnitFamily({
            multicell: multicellShape,
            unmergeable: true,
            movable: {
                laborday26: false
            },
            important: true,
            spawner: true,
            guide: {
                default: {
                    name: "AdvGeneratorGuideWindow",
                    bundle: bundles.advgenerator_guide_window
                },
                ...guideWindowByLocation
            }
        }, {
            type: "advgenerator",
            expeditions: this.ADV2_PLUS_IDS
        });
    },

    registerCustomerFamilies: function () {
        // advdynamite
        Families.advdynamite = AdventureFamiliesHelper.SpecialUnitFamily({
            dynamite: { radius: 3 }
        }, { expeditions: this.EXPEDITION_IDS });

        // Adventure 1 customers
        Families.advcustomerbridge0 = AdventureFamiliesHelper.AdventureCustomerFamily({
            stopsfog: false,
            type: "advcustomer",
            expeditions: "adventure"
        });

        Families.advcustomerbridge1 = AdventureFamiliesHelper.AdventureCustomerFamily({
            multicell: FamiliesHelper.DeprecatedShapes.ShapeXArc,
            composite: true,
            type: "advcustomer",
            expeditions: "adventure"
        });

        Families.advcustomerbridge2 = AdventureFamiliesHelper.AdventureCustomerFamily({
            composite: true,
            multicell: FamiliesHelper.Shape1x6,
            type: "advcustomer",
            expeditions: "adventure"
        });

        Families.advcustomermain1 = AdventureFamiliesHelper.AdventureCustomerFamily({
            multicell: FamiliesHelper.Shape3x3,
            type: "advcustomer",
            expeditions: "adventure"
        });

        Families.advcustomermain2 = AdventureFamiliesHelper.AdventureCustomerFamily({
            finishHint: true,
            type: "advcustomer",
            expeditions: "adventure"
        });
    },

    registerProducerFamilies: function () {
        // adv3 building families
        Families.adv3rpcustomermain0 = FamiliesHelper.ExpeditionBuildingFamily({
            landmarkDonor: true,
            multicell: {
                default: FamiliesHelper.ShapeSquare
            },
            expeditions: this.NEWER_EXPEDITION_IDS
        });
        Families.adv3rpcustomermain1 = FamiliesHelper.ExpeditionBuildingFamily({
            landmarkDonor: true,
            multicell: {
                default: FamiliesHelper.ShapeSquare
            },
            expeditions: this.NEWER_EXPEDITION_IDS
        });
        Families.adv3rpcustomermain2 = FamiliesHelper.ExpeditionBuildingFamily({
            landmarkDonor: true, multicell: FamiliesHelper.ShapeSquare, expeditions: this.NEWER_EXPEDITION_IDS
        });
        Families.adv3rpcustomermain3 = FamiliesHelper.ExpeditionBuildingFamily({
            landmarkDonor: true, hasShowUp: true, multicell: FamiliesHelper.ShapeSquare, expeditions: this.NEWER_EXPEDITION_IDS
        });
        Families.adv3rpcustomermain4 = FamiliesHelper.ExpeditionBuildingFamily({
            landmarkDonor: true, multicell: Object.fromEntries(this.NEWER_EXPEDITION_IDS.map((id) => [id, id === "pirates" ? undefined : FamiliesHelper.ShapeSquare])), expeditions: this.NEWER_EXPEDITION_IDS
        });

        // adv3 product families
        Families.adv3rpproduct0 = FamiliesHelper.ExpeditionProductFamily({
            locators: ["adv3rpproducer0"], type: "adv3rpproduct0", expeditions: this.NEWER_EXPEDITION_IDS_CLASSIC_PRODUCT, produceOnlyWhenNeeded: true
        });
        Families.adv3rpproduct1 = FamiliesHelper.ExpeditionProductFamily({
            locators: ["adv3rpproducer1"], type: "adv3rpproduct1", expeditions: this.NEWER_EXPEDITION_IDS_CLASSIC_PRODUCT, produceOnlyWhenNeeded: true
        });
        Families.adv3rpproduct2 = FamiliesHelper.ExpeditionProductFamily({
            locators: ["adv3rpproducer2"], type: "adv3rpproduct2", expeditions: this.NEWER_EXPEDITION_IDS_CLASSIC_PRODUCT, produceOnlyWhenNeeded: true
        });
        Families.adv3rpproduct3 = FamiliesHelper.ExpeditionProductFamily({
            locators: ["adv3rpproducer3"], type: "adv3rpproduct3", expeditions: this.NEWER_EXPEDITION_IDS_CLASSIC_PRODUCT, produceOnlyWhenNeeded: true
        });
        Families.adv3rpproduct4 = FamiliesHelper.ExpeditionProductFamily({
            locators: ["adv3rpproducer4"], type: "adv3rpproduct4", expeditions: this.NEWER_EXPEDITION_IDS_CLASSIC_PRODUCT, produceOnlyWhenNeeded: true
        });

        Families.advproduct0 = AdventureFamiliesHelper.AdventureProductFamily({
            locators: ["adv3rpproducer0"], type: "adv3rpproduct0", expeditions: this.NEW_PRODUCT_IDS, produceOnlyWhenNeeded: true
        });
        Families.advproduct1 = AdventureFamiliesHelper.AdventureProductFamily({
            locators: ["adv3rpproducer1"], type: "adv3rpproduct1", expeditions: this.NEW_PRODUCT_IDS, produceOnlyWhenNeeded: true
        });
        Families.advproduct2 = AdventureFamiliesHelper.AdventureProductFamily({
            locators: ["adv3rpproducer2"], type: "adv3rpproduct2", expeditions: this.NEW_PRODUCT_IDS, produceOnlyWhenNeeded: true
        });
        Families.advproduct3 = AdventureFamiliesHelper.AdventureProductFamily({
            locators: ["adv3rpproducer3"], type: "adv3rpproduct3", expeditions: this.NEW_PRODUCT_IDS, produceOnlyWhenNeeded: true
        });
        Families.advproduct4 = FamiliesHelper.ExpeditionProductFamily({
            locators: ["adv3rpproducer4"], type: "adv3rpproduct4", expeditions: this.NEW_PRODUCT_IDS, produceOnlyWhenNeeded: true
        });

        // adv3 producer/customer families
        Families.adv3rpproducer0 = FamiliesHelper.ExpeditionCustomerFamily({
            type: "adv3rpcustomer",
            hasShowUp: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            impassable: true,
            multicell: {
                nightparty: FamiliesHelper.ShapeSquare,
                pirates: FamiliesHelper.ShapeSquare,
                laborday26: FamiliesHelper.ShapeSquare
            },
            movable: {
                earthday: false,
                nightparty: false,
                laborday26: false,
                pirates: false
            }
        });
        Families.adv3rpproducer1 = FamiliesHelper.ExpeditionCustomerFamily({
            type: "adv3rpcustomer",
            hasShowUp: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            impassable: true,
            multicell: {
                nightparty: FamiliesHelper.ShapeSquare,
                pirates: FamiliesHelper.ShapeSquare,
                laborday26: FamiliesHelper.ShapeSquare
            },
            movable: {
                earthday: false,
                nightparty: false,
                laborday26: false,
                pirates: false
            }
        });
        Families.adv3rpproducer2 = FamiliesHelper.ExpeditionCustomerFamily({
            type: "adv3rpcustomer",
            hasShowUp: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            impassable: true,
            multicell: {
                nightparty: FamiliesHelper.ShapeSquare,
                pirates: FamiliesHelper.ShapeSquare,
                laborday26: FamiliesHelper.ShapeSquare
            },
            movable: {
                earthday: false,
                nightparty: false,
                laborday26: false,
                pirates: false
            }
        });
        Families.adv3rpproducer3 = FamiliesHelper.ExpeditionCustomerFamily({
            type: "adv3rpcustomer",
            hasShowUp: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            impassable: true,
            multicell: {
                nightparty: FamiliesHelper.ShapeSquare,
                pirates: FamiliesHelper.ShapeSquare,
                laborday26: FamiliesHelper.ShapeSquare
            },
            movable: {
                earthday: false,
                nightparty: false,
                laborday26: false,
                pirates: false
            }
        });
        Families.adv3rpproducer4 = FamiliesHelper.ExpeditionCustomerFamily({
            type: "adv3rpcustomer",
            hasShowUp: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            impassable: true,
            multicell: {
                nightparty: FamiliesHelper.ShapeSquare,
                pirates: FamiliesHelper.ShapeSquare,
                laborday26: FamiliesHelper.ShapeSquare
            },
            movable: {
                earthday: false,
                nightparty: false,
                laborday26: false,
                pirates: false
            }
        });

        // adv3 bridge families
        Families.adv3rpcustomerbridge0 = FamiliesHelper.ExpeditionBuildingFamily({
            multicell: {
                adventureny: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                adventurevd: FamiliesHelper.Shape2x3Vertical,
                patrickday: FamiliesHelper.Shape1x3Vertical,
                earthday: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                nightparty: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                pirates: FamiliesHelper.Shape1x3Vertical,
                laborday26: AdventureFamiliesHelper.ShapeSquarePassableStrip,
                adventure3: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                adventure4: FamiliesHelper.ShapeSquarePassableLeftAnchor
            },
            squeezable: false,
            stopsfog: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            composite: true
        });

        Families.adv3rpcustomerbridge1 = FamiliesHelper.ExpeditionBuildingFamily({
            squeezable: false,
            stopsfog: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            composite: true,
            multicell: {
                adventureny: FamiliesHelper.DeprecatedShapes.ShapeSquarePassableRightAnchor,
                adventurevd: FamiliesHelper.DeprecatedShapes.ShapeSquarePassableRightAnchor,
                patrickday: FamiliesHelper.Shape1x2Horizontal,
                earthday: FamiliesHelper.Shape1x3Vertical,
                laborday26: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                adventure3: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                nightparty: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                pirates: FamiliesHelper.Shape1x4Vertical,
                adventure4: FamiliesHelper.DeprecatedShapes.Shape3x1AnchorRight
            }
        });

        Families.adv3rpcustomerbridge2 = FamiliesHelper.ExpeditionBuildingFamily({
            multicell: {
                adventureny: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                adventurevd: FamiliesHelper.DeprecatedShapes.ShapeSquarePassableTopAnchor,
                patrickday: FamiliesHelper.Shape1x3Vertical,
                earthday: FamiliesHelper.Shape1x5Horizontal,
                adventure3: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                laborday26: FamiliesHelper.Shape1x4Horizontal,
                nightparty: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                pirates: FamiliesHelper.Shape1x4Vertical,
                adventure4: FamiliesHelper.ShapeSquarePassableLeftAnchor
            },
            squeezable: false,
            stopsfog: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            composite: true
        });

        Families.adv3rpcustomerbridge3 = FamiliesHelper.ExpeditionBuildingFamily({
            multicell: {
                adventureny: FamiliesHelper.DeprecatedShapes.Shape2x3PassableStrip,
                adventurevd: FamiliesHelper.DeprecatedShapes.Shape2x3PassableStrip,
                patrickday: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                adventure3: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                laborday26: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                nightparty: AdventureFamiliesHelper.Shape2x4Vertical,
                pirates: FamiliesHelper.Shape1x4Vertical,
                earthday: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                adventure4: FamiliesHelper.ShapeSquarePassableLeftAnchor
            },
            composite: true,
            squeezable: false,
            stopsfog: true,
            expeditions: this.NEWER_EXPEDITION_IDS
        });

        Families.adv3rpcustomerbridge4 = FamiliesHelper.ExpeditionBuildingFamily({
            multicell: {
                adventureny: FamiliesHelper.DeprecatedShapes.Shape2x3Passable,
                adventurevd: FamiliesHelper.DeprecatedShapes.Shape2x3Passable,
                patrickday: FamiliesHelper.Shape1x3Vertical,
                adventure3: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                nightparty: FamiliesHelper.ShapeSquarePassableLeftAnchor,
                laborday26: FamiliesHelper.Shape1x4Horizontal,
                pirates: FamiliesHelper.Shape1x3Vertical,
                earthday: FamiliesHelper.Shape1x4Horizontal,
                adventure4: FamiliesHelper.DeprecatedShapes.ShapeSquarePassableTopAnchor
            },
            squeezable: false,
            stopsfog: true,
            expeditions: this.NEWER_EXPEDITION_IDS,
            composite: true
        });
    },

    registerMiscFamilies: function () {
        Families.exprunes = FamiliesHelper.AdvQuestItemsFamily(5, {
            expeditions: ["adventure4"],
            quest: "exprunes",
            type: "runes"
        });

        ["exprunes1", "exprunes2", "exprunes3", "exprunes4"].forEach((code) => {
            Families[code] = FamiliesHelper.AdvQuestItemsFamily(5, {
                expeditions: this.NEW_SOURCE_IDS,
                quest: code,
                type: "runes"
            });
        });

        ["sidequest1", "sidequest2", "sidequest5", "sidequest6"].forEach((code) => {
            Families[code] = FamiliesHelper.AdvQuestItemsFamily(1, {
                expeditions: this.NEW_SOURCE_IDS,
                quest: code,
                type: "sidequest"
            });
        });

        ["sidequest3", "sidequest4"].forEach((code) => {
            Families[code] = FamiliesHelper.AdvQuestItemsFamily(1, {
                expeditions: [],
                quest: code,
                type: "sidequest"
            });
        });

        Families.emeralds = FamiliesHelper.AdvQuestItemsFamily(1, {
            expeditions: ["adventure4"],
            quest: "emeralds",
            type: "emeralds"
        });

        Families.berries = FamiliesHelper.AdvQuestItemsFamily(2, {
            expeditions: ["adventure4"],
            quest: "berries",
            type: "berries"
        });

        // Expedition red chest
        // Families.expredchest = FamiliesHelper.ExpeditionChestFamily({
        //     resource: "expredchest",
        //     type: "expredchest",
        //     expeditions: this.NEWER_EXPEDITION_IDS
        // });
    }
};

if (typeof cc === "undefined") {
    module.exports = AdventureFamilies;
}